import { createAsyncThunk } from '@reduxjs/toolkit';
import TrendingAPI from './trendingAPI';

export const createTrendingItemThunk = createAsyncThunk(
  'trending/create',
  async (itemData, { rejectWithValue }) => {
    try {
      return await TrendingAPI.create(itemData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTrendingItemsThunk = createAsyncThunk(
  'trending/fetchAll',
  async ({ skip = 0, limit = 10 }, { rejectWithValue }) => {
    try {
      return await TrendingAPI.fetchAll(skip, limit);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTrendingItemByIdThunk = createAsyncThunk(
  'trending/fetchOne',
  async (itemId, { rejectWithValue }) => {
    try {
      return await TrendingAPI.fetchOne(itemId);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateTrendingItemThunk = createAsyncThunk(
  'trending/update',
  async ({ itemId, itemData }, { rejectWithValue }) => {
    try {
      return await TrendingAPI.update(itemId, itemData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTrendingItemThunk = createAsyncThunk(
  'trending/delete',
  async (itemId, { rejectWithValue }) => {
    try {
      return await TrendingAPI.delete(itemId);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const incrementTrendingViewThunk = createAsyncThunk(
  "trending/incrementView",
  async (postId, { rejectWithValue }) => {
    try {
      return await TrendingAPI.incrementView(postId);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchTrendingPostsForStock = createAsyncThunk(
  "trending/fetchTrendingPostsForStock",
  async ({ symbol, skip = 0, limit = 10 }, thunkAPI) => {
    try {
      return await TrendingAPI.fetchTrendingPostsForStock(symbol, skip, limit);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }

  
);

export const fetchTrendingBatchThunk = createAsyncThunk(
  "trending/fetchTrendingBatch",
  async ({ symbols, skip = 0, limit = 10 }, thunkAPI) => {
    try {
      return await TrendingAPI.fetchTrendingBatch(symbols, skip, limit);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);
